<template lang="html">
  <div class="telehealth">
    <div class="content telehealth-content" ref="telehealthContent">
      <div class="telehealth-form main-content-cj h-100 mh-100">
        <b-container class="d-flex flex-column h-100 mh-100">
          <div class="box-container">
            <b-form-row>
              <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <div class="box-cj mb-3">
                  <div class="content">
                    <b-row v-if="telehealthAppointment != null">
                      <b-col cols="12" lg="6" class="d-flex flex-column justify-content-center mb-3 mb-lg-0">
                        <h4 class="font-lighter mb-0">{{telehealthAppointment.appointment_type.type}} com {{telehealthAppointment.professional.name}}</h4>
                      </b-col>
                      <b-col class="d-flex flex-column justify-content-center text-lg-right">
                        <p class="mb-1">Paciente: {{telehealthAppointment.patient.name}}<i class="far fa-user ml-2"></i></p>
                        <p class="mb-0">Início: {{moment(telehealthAppointment.start_datetime).format('HH:mm')}}<i class="far fa-clock ml-2"></i></p>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>

              <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <div class="box-cj mb-0">
                  <div id="attendance_content" class="content p-0 d-flex justify-content-center align-items-center">
                    <div v-if="telehealthAttendance != null && (telehealthAttendance.start_datetime == null || !telehealthAttendance.patient_entered)" class="text-center">
                      <div v-if="!telehealthAttendance.patient_entered" class="mb-3 patient-status-text">O paciente ainda não entrou.</div>
                      <div v-else class="mb-3 patient-status-text"><i class="far fa-clock text-primary mr-2"></i>Aguardando {{telehealthAppointment.professional.name}}.</div>
                    </div>
                    <div v-else-if="telehealthAttendance != null && telehealthAttendance.start_datetime != null && telehealthAttendance.end_datetime == null" class="agora-uikit-cj">
                      <div class="agora-call">
                        <div id="participants"></div>
                        <div style="background-color: rgb(0, 123, 255); width: 100%; height: 70px; z-index: 10; display: flex; flex-direction: row; justify-content: space-evenly; align-items: center;">
                          <b-button @click="toggleCamera()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-video' + (videoEnabled ? '' : '-slash')"></i></b-button>
                          <b-button @click="toggleMicrophone()" variant="primary" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i :class="'far fa-microphone' + (audioMuted ? '-slash' : '')"></i></b-button>
                          <b-button @click="endTelehealthAttendance()" variant="danger" pill lg style="width: 38px;font-size:18px" class="px-0 text-center"><i class="far fa-phone-slash"></i></b-button>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="telehealthAttendance != null && telehealthAttendance.end_datetime != null" class="text-center">
                      <div class="mb-3">Teleconsulta finalizada.</div>
                      <router-link tag="a" class="btn btn-block btn-primary" :to="'/'">Sair</router-link>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-form-row>
          </div>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
// import {compressToUTF16, decompressFromUTF16} from "lz-string";
  import AgoraRTC from "agora-rtc-sdk-ng";

  export default {
    data() {
      return {
        leavingPage: false,

        isMobile: false,
        agoraId: process.env.VUE_APP_AGORA_ID,
        agoraToken: '',
        agoraClient: null,
        localAudioTrack: null,
        audioMuted: false,
        localVideoTrack: null,
        loadedChannel: false,
        leftChannel: false,
        videoEnabled: true,
        spectators: [],

        telehealthCheckInterval: null,

        user: null,

        termSingular: '',
        url: '',
        module: '',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,


        telehealthAppointment: null,
        telehealthAttendance: null
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.termSingular = 'paciente';
      this.url = 'pacientes';
      this.module = 'patients';

      this.canSee = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner())?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false || this.user.person.type != 'PROFESSIONAL' || !this.helpers.planHasPermission('telehealth') || !this.user.person.client.enable_multi_professional_telehealth_attendance) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      document.addEventListener('focusin', function (e) {
        let closest = e.target.closest('.swal2-input');
        if (closest !== null && closest !== undefined) {
          e.stopImmediatePropagation();
        }
      });

      await this.api.getSpectateTelehealthAppointmentData(this.$route.params.patientId, this.$route.params.id).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.canPerformAction = true;
        this.eventBus.$emit('IS_LOADING', false);

        this.agoraToken = res.data.agora_token;
        this.telehealthAppointment = res.data.telehealth_appointment;
        this.telehealthAttendance = res.data.telehealth_attendance;
        this.spectators = res.data.spectators;

        if(this.telehealthAttendance.start_datetime == null || this.telehealthAttendance.end_datetime == null) {
          this.telehealthCheckInterval = setInterval(this.checkTelehealthAttendance, 15*1000);
          if(this.telehealthAttendance.start_datetime != null) {
              this.initializeClient();
              this.joinChannel();
          }
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Spectate Telehealth Appointment Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.canPerformAction = true;
        this.eventBus.$emit('IS_LOADING', false);
        try {
          let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, entre em contato com o suporte!';
          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
          }
          this.$swal('Ops...', msg, 'error');
          this.$router.push({path: '/' + this.url + '/' + this.$route.params.patientId}).catch(() => {});

          this.$swal('Ops...', msg, 'error');
        } catch(err2) {
          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchGetSpectateTelehealthAppointmentData\nError:'+err.toString(), 'warning');
          this.sentry.captureException(err);
        }

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Spectate Telehealth Appointment Data', err.response);
      });
    },
    methods: {
      async checkTelehealthAttendance() {
        await this.api.checkTelehealthAttendance(this.$route.params.patientId, this.telehealthAttendance.id).then(res => {
          if(this.leavingPage) {
            return;
          }
          this.telehealthAttendance = res.data;

          if(this.telehealthAttendance.end_datetime != null) {
            clearInterval(this.telehealthCheckInterval)
            this.telehealthCheckInterval = null;
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Telehealth Attendance', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          let msg = 'Não conseguimos carregar este atendimento de teleconsulta! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';
          switch (err.response.status) {
            case 400:
              msg = err.response.data.message;
              break;
          }
          if(msg === 'Este atendimento já foi encerrado!') {
            if(this.telehealthAttendance.end_datetime == null) {
              this.telehealthAttendance.end_datetime = 1;
            }
            else {
              msg = null;
            }
          }
          if(msg) {
            this.$swal('Ops...', msg, 'error');
          }

          clearInterval(this.telehealthCheckInterval)
          this.telehealthCheckInterval = null;

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Telehealth Attendance', err);
        });
      },
      initializeClient() {
        this.agoraClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
        this.setupAgoraEventListeners();
      },
      setupAgoraEventListeners() {
        this.agoraClient.on('user-published', async (user, mediaType) => {
          if(!this.leftChannel) {
            await this.agoraClient.subscribe(user, mediaType);
            this.loadParticipants();
          }
        });

        this.agoraClient.on('user-unpublished', async (user) => {
          if(!this.leftChannel) {
            let remotePlayerContainer = document.getElementById(user.uid);
            if(remotePlayerContainer) {
              let audioIndicator = remotePlayerContainer.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
                  noAudioIndicator = remotePlayerContainer.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
              audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
              noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
            }
          }
        });

        this.agoraClient.on('user-left', async (user) => {
          if(!this.leftChannel) {
            let remotePlayerContainer = document.getElementById(user.uid);
            if (remotePlayerContainer) {
              remotePlayerContainer && remotePlayerContainer.remove();
            }
            setTimeout(() => {
              let container = document.getElementById('participants');
              if(container) {
                container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
              }
              else {
                setTimeout(() => {
                  let container = document.getElementById('participants');
                  if(container) {
                    container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);
                  }
                }, 500);
              }
            }, 500);
          }
        });
      },

      async joinChannel() {
        await this.agoraClient.join(this.agoraId, this.telehealthAttendance.id, this.agoraToken, this.user.person.id);
        await this.createLocalMediaTracks();
        await this.publishLocalTracks();
        this.loadParticipants();
        this.loadedChannel = true;
      },
      async createLocalMediaTracks() {
        this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
        this.localVideoTrack = await AgoraRTC.createCameraVideoTrack();
      },
      async publishLocalTracks() {
        await this.agoraClient.publish([this.localAudioTrack, this.localVideoTrack]);
      },
      loadParticipants() {
        if(!this.localVideoTrack) {
          return;
        }
        let container = document.getElementById('participants');
        if(!container) {
          setTimeout(() => {
            this.loadParticipants();
          }, 500);
          return;
        }
        container.style.gridTemplateColumns = this.getAgoraGridStyle(this.agoraClient.remoteUsers.length + 1);

        let professionalUser = this.agoraClient.remoteUsers.find(user => user.uid === this.telehealthAppointment.professional.id);
        if(professionalUser) {
          this.displayRemoteVideo(container, this.telehealthAppointment.professional.name, professionalUser, -5);
        }

        let patientUser = this.agoraClient.remoteUsers.find(user => user.uid === this.telehealthAppointment.patient.id);
        if(patientUser) {
          this.displayRemoteVideo(container, 'Paciente ' + this.telehealthAppointment.patient.name, patientUser, -10);
        }
        if(!document.getElementById(this.user.person.id)) {
          this.displayLocalVideo(container);
        }

        this.agoraClient.remoteUsers.forEach((user) => {
          if([this.telehealthAppointment.professional.id, this.telehealthAppointment.patient.id].indexOf(user.uid) === -1) {
            let spectator = this.spectators.find(spectator => spectator.id === user.uid);
            this.displayRemoteVideo(container, spectator ? spectator.name : '', user, null);
          }
        });
      },
      displayLocalVideo(container) {
        container.insertAdjacentHTML('beforeend', '' +
          '<div id="' + this.user.person.id + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%">' +
            '<div style="display: flex; flex: 1 1 0; position: relative">' +
              '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">' + this.user.person.name + '</p>' +
              '<div class="participant-video participant-' + this.user.person.id + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
              '<i class="fas fa-microphone text-white participant-audio participant-' + this.user.person.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
              '<div class="text-white participant-no-audio participant-' + this.user.person.id + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
              '</div>' +
            '</div>' +
          '</div>');
        this.localVideoTrack.play(document.querySelectorAll('.participant-video.participant-' + this.user.person.id)[0]);
      },
      displayRemoteVideo(container, name, user, order) {
        if(!document.getElementById(user.uid)) {
          container.insertAdjacentHTML('beforeend', '' +
              '<div id="' + user.uid + '" style="display: flex; flex: 1 1 0; height: 100%; width: 100%; ' + (order !== null ? ('order: ' + order) : '') + '">' +
                '<div style="display: flex; flex: 1 1 0; position: relative">' +
                  '<p style="position: absolute; background: rgba(0, 123, 255, 0.667); padding: 2px 8px; color: rgb(255, 255, 255); margin: 0px; bottom: 0px; right: 0px; z-index: 90;">' + name + '</p>' +
                  '<div class="participant-video participant-' + user.uid + '" style="flex: 1 1 0%; display: flex; background-color: rgba(0, 123, 255, 0.2); flex-direction: row; position: relative;"></div>' +
                  '<i class="fas fa-microphone participant-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none"></i>' +
                  '<div class="text-white participant-no-audio participant-' + user.uid + '" style="position: absolute;top: 50%;width: 100%;text-align: center;font-size: 40px;display:none">' +
                    '<div style="display:inline;border-radius:100%;background: rgba(0,0,0,0.2)"><i class="fas fa-microphone-slash" style="opacity:.85"></i></div>' +
                  '</div>' +
                '</div>' +
              '</div>');
        }
        if(user.hasVideo && user.videoTrack && !user.videoTrack.isPlaying) {
          user.videoTrack.play(document.querySelectorAll('.participant-video.participant-' + user.uid)[0]);
        }
        if(user.hasAudio && user.audioTrack && !user.audioTrack.isPlaying) {
          user.audioTrack.play();
        }
        let audioIndicator = document.querySelectorAll('.participant-audio.participant-' + user.uid)[0],
            noAudioIndicator = document.querySelectorAll('.participant-no-audio.participant-' + user.uid)[0];
        if(audioIndicator) {
          audioIndicator.style.display = user.hasVideo || !user.hasAudio ? 'none' : 'block';
        }
        if(noAudioIndicator) {
          noAudioIndicator.style.display = user.hasAudio ? 'none' : 'block';
        }
      },
      getAgoraGridStyle(amount) {
        let gridCellStyle = 'minmax(0px, 1fr)',
            gridStyle = [gridCellStyle];
        if(amount > 1) {
          gridStyle.push(gridCellStyle);
          if(amount > 4) {
            gridStyle.push(gridCellStyle);
          }
        }
        return gridStyle.join(' ');
      },
      toggleCamera() {
        this.videoEnabled = !this.videoEnabled;
        if(this.localVideoTrack) {
          this.localVideoTrack.setEnabled(this.videoEnabled);
        }
        let participantAudio = document.querySelectorAll('.participant-audio.participant-' + this.user.person.id);
        if(participantAudio) {
          participantAudio[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
        }
        let participantNoAudio = document.querySelectorAll('.participant-no-audio.participant-' + this.user.person.id);
        if(participantNoAudio) {
          participantNoAudio[0].style.display = !this.audioMuted ? 'none' : 'block';
        }
      },
      toggleMicrophone() {
        this.audioMuted = !this.audioMuted;
        if(this.localAudioTrack) {
          this.localAudioTrack.setMuted(this.audioMuted);
        }
        let participantAudio = document.querySelectorAll('.participant-audio.participant-' + this.user.person.id);
        if(participantAudio) {
          participantAudio[0].style.display = this.videoEnabled || this.audioMuted ? 'none' : 'block';
        }
        let participantNoAudio = document.querySelectorAll('.participant-no-audio.participant-' + this.user.person.id);
        if(participantNoAudio) {
          participantNoAudio[0].style.display = !this.audioMuted ? 'none' : 'block';
        }
      },
      async leaveChannel() {
        this.leftChannel = true;
        if (this.localAudioTrack) {
          this.localAudioTrack.close();
          this.localAudioTrack = null;
        }
        if (this.localVideoTrack) {
          this.localVideoTrack.close();
          this.localVideoTrack = null;
        }
        let container = document.getElementById('participants');
        if(container) {
          container.innerHTML = '';
        }
        await this.agoraClient.leave();
      },

      async endTelehealthAttendance() {
        if(!this.canPerformAction)
          return false;

        this.$swal({
          title: 'Sair da chamada',
          text: 'Tem certeza que deseja sair desta chamada de teleconsulta?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sair da chamada',
          cancelButtonText: 'Cancelar',
          focusConfirm: true
        }).then((res) => {
          if(res.value) {
            this.telehealthAttendance.end_datetime = 1;
            this.leaveChannel();
            this.$router.push({ path: '/' }).catch(() => {});
          }
        });
      },
    },

    beforeDestroy() {
      if(this.telehealthLayoutInterval != null) {
        clearInterval(this.telehealthLayoutInterval);
      }
      if(this.telehealthCheckInterval != null) {
        clearInterval(this.telehealthCheckInterval);
      }
      this.leaveChannel();
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .telehealth {
    display: flex;
    overflow: hidden;
    min-height: 100vh;

    .telehealth-content {
      flex: 1;
      background-color: #f0f2f8;
      height: 100vh;
      overflow: scroll;
      overflow-x: hidden;
    }
  }

  @media (max-width: 767px) {
    .telehealth {
      flex-flow: column wrap;
    }

    //.telehealth-content {
    //  margin-top: 86px;
    //  height: calc(100vh - 86px) !important;
    //}
  }


  .telehealth-form {
    padding: 14px 0;
  }

  .patient-status-text {
    font-size: 18px;
  }

  #attendance_content {
    height: 945px;
  }
  .agora-uikit-cj {
    width: 100%;
    height: 100%;
    display: flex;

    .agora-call {
      min-height: 0px;
      display: flex;
      flex: 1 1 0;
      flex-direction: column;

      #participants {
        width: 100%;
        height: 100%;
        display: grid;
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }
  @media (max-height: 1100px) {
    #attendance_content {
      height: calc(100vh - 180px)!important;
    }
  }
  @media (max-height: 991px) {
    #attendance_content {
      min-height: 450px;
    }
  }
</style>
